import { createSlice } from '@reduxjs/toolkit'

const initialState = {

    channelPartnerListLoading: false,
    channelPartnerListSuccess: null,
    channelPartnerListError: '',

    getChannelPartnerDetailsLoading: false,
    getChannelPartnerDetailsSuccess: {},
    getChannelPartnerDetailsError: '',

    getChannelPartnerDataLoading: false,
    getChannelPartnerDataSuccess: {},
    getChannelPartnerDataError: '',

}

export const channelPartnerSlice = createSlice({
    name: 'channelPartner',
    initialState,
    reducers: {

        setChannelPartnerListLoading: (state, action) => {
            state.channelPartnerListLoading = true;
            state.channelPartnerListSuccess = null;
            state.channelPartnerListError = '';
        },
        setChannelPartnerListSuccess: (state, action) => {
            state.channelPartnerListLoading = false;
            state.channelPartnerListSuccess = action.payload;
            state.channelPartnerListError = '';
        },
        setChannelPartnerListError: (state, action) => {
            state.channelPartnerListLoading = false;
            state.channelPartnerListSuccess = null;
            state.channelPartnerListError = action.payload;
        },

        getChannelPartnerDetailsLoading: (state) => {
            state.getChannelPartnerDetailsLoading = true;
            state.getChannelPartnerDetailsSuccess = {};
            state.getChannelPartnerDetailsError = '';
        },
        getChannelPartnerDetailsSuccess: (state, action) => {
            state.getChannelPartnerDetailsLoading = false;
            state.getChannelPartnerDetailsSuccess = action.payload;
            state.getChannelPartnerDetailsError = '';
        },
        getChannelPartnerDetailsError: (state, action) => {
            state.getChannelPartnerDetailsLoading = false;
            state.getChannelPartnerDetailsSuccess = {};
            state.getChannelPartnerDetailsError = action.payload;
        },

        getChannelPartnerLoading: (state) => {
            state.getChannelPartnerDataLoading = true;
            state.getChannelPartnerDataSuccess = {};
            state.getChannelPartnerDataError = '';
        },
        getChannelPartnerSuccess: (state, action) => {
            state.getChannelPartnerDataLoading = false;
            state.getChannelPartnerDataSuccess = action.payload;
            state.getChannelPartnerDataError = '';
        },
        getChannelPartnerError: (state, action) => {
            state.getChannelPartnerDataLoading = false;
            state.getChannelPartnerDataSuccess = {};
            state.getChannelPartnerDataError = action.payload;
        },

        resetChannelPartnerContent: (state, action) => {
            state.getChannelPartnerDataSuccess = {};
        },

    },
})

export const {
    setChannelPartnerListLoading, setChannelPartnerListSuccess, setChannelPartnerListError,
    getChannelPartnerDetailsLoading, getChannelPartnerDetailsSuccess, getChannelPartnerDetailsError,
    getChannelPartnerLoading, getChannelPartnerSuccess, getChannelPartnerError, resetChannelPartnerContent

} = channelPartnerSlice.actions

export default channelPartnerSlice.reducer;